<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <div class="search-box mr-2 mb-2 d-inline-block ">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Digite e pressione 'ENTER'" @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right" v-if="user.role === 'Admin'">
                    <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newCupom()">
                      <i class="mdi mdi-plus mr-1"></i> Novo Cupom
                    </button>
                  </div>
                  <div class="text-sm-right">
                    <button type="button" class="btn  btn-dark btn-rounded mb-2 mr-2" @click="exportCupons()">
                      <i class="mdi mdi-file-export-outline mr-1"></i> Exportar
                    </button>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="30%">Descrição</th>
                    <th width="20%">Responsável</th>
                    <th width="10%">Código</th>
                    <th width="10%">Desconto</th>
                    <th width="10%">Status</th>
                    <th width="10%">Usado</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in cupons" :key="list.id">
                    <td class="link" @click="editCupom(list.id)">{{ list.description }}</td>
                    <td class="link" @click="editCupom(list.id)">{{ list.manager }}</td>
                    <td class="link" @click="editCupom(list.id)">{{ list.cupom }}</td>
                    <td class="link" @click="editCupom(list.id)">{{ list.discount + '%'}}</td>
                    <td>
                      <b-dropdown
                        size="sm"
                        style="min-width:100px"
                        :variant="(parseInt(list.status)) === 1 ? 'success' : 'danger'"
                      >
                        <template v-slot:button-content >
                          {{ parseInt(list.status) === 1 ? 'Ativo' : 'Inativo' }}
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <span>
                          <b-dropdown-item-button @click="toggleStatus(list.id)">Ativar</b-dropdown-item-button>
                          <b-dropdown-item-button @click="toggleStatus(list.id)">Inativar</b-dropdown-item-button>
                        </span>
                      </b-dropdown>
                    </td>
                    <td class="link" @click="editCupom(list.id)">{{ list.used ? 'SIM' : 'NÃO'}}</td>
                    <td><button v-if="user.role === 'Admin'" type="button" @click="deleteCupom(list)" class="link btn btn-outline-danger btn-sm"><i class="bx bx-trash"></i></button></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <modal-form v-model="modalForm" :idCupom="idCupom" ref="formCupom" @created="updateList"></modal-form>
    <modal-form-edit v-model="modalFormEdit" :idCupom="idCupom" ref="formCupomEdit" @created="updateList"></modal-form-edit>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import ModalForm from './Form'
import ModalFormEdit from './Edit'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import service from './services'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Layout,
    PageHeader,
    ModalForm,
    ModalFormEdit
  },
  name: 'cupons',
  page: {
    title: 'Cupons de Descontos',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      search: '',
      timeout: null,
      modalForm: false,
      modalFormEdit: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      idCupom: null,
      perPage: 20,
      statusLabel: ['Inativo', 'Ativo'],
      descType: ['PRESENCIAL', 'ONLINE'],
      submitted: false,
      title: 'Cupons de Descontos',
      items: [{
        text: 'Cupons de Descontos'
      },
      {
        text: 'Listagem',
        active: true
      }
      ]
    }
  },
  mounted () {
    this.updateList()
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('cupon', ['cupons', 'pagination']),
    rows () {
      return this.pagination.total
    }
  },
  methods: {
    ...mapActions('cupon', {
      getAll: 'getAll',
      delete: 'deleteCupom',
      changeStatus: 'changeStatus'
    }),
    exportCupons () {
      let loeader = this.$loading.show()
      service.exportCupom(this.params).then((res) => {
        this.download(res)
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    newCupom () {
      this.$refs.formCupom.open('')
      this.modalForm = true
    },
    editCupom (id) {
      if (this.user.role === 'Admin') {
        this.$refs.formCupomEdit.open(id)
        this.modalFormEdit = true
        this.idCupom = id
      }
    },
    async toggleStatus (id) {
      try {
        await this.changeStatus(id)
        let message = 'Sucesso: Status atualizado com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.updateList()
      } catch (err) {
        console.log(err)
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    deleteCupom (cupon) {
      Swal.fire({
        title: 'Você tem certeza ?',
        html: `Será excluido o cupom: <b>${cupon.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.delete(cupon.id)
            successMessage('Sucesso: Cupom excluído com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px;}
.float-sm-end { float: right }
</style>
